import * as bi from 'react-bootstrap-icons';
import { Button, Flex, Input, Message, TextContent } from 'components';
import { useState } from 'react';
import { phoneClear, phoneFormat, phoneIsValid } from '../../../../helpers';
import { handleEnterDown } from 'common/handlers';

interface IProps {
  onRegisterClick: (phone: string) => void;
}

function FramePhone(props: IProps) {
  const [phone, setPhone] = useState<string>('');
  const [isError, setError] = useState<boolean>(true);

  const handlePhoneChange = (phone: string) => {
    const cleared = phoneClear(phone);
    setPhone(phoneFormat(cleared));
    setError(!phoneIsValid(cleared));
  };

  const handlePhoneKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => handleEnterDown(e, handleRegisterClick);

  const handleRegisterClick = () => {
    if (!isError) {
      props.onRegisterClick(phone.trim());
    }
  };

  return (
    <Flex
      direction='column'
      gap={20}
    >
      <TextContent align='center'>Для регистрации в сервисе укажите ваш актуальный номер телефона</TextContent>
      <Flex
        direction='column'
        gap={10}
      >
        <Input
          type='text'
          icon={<bi.Phone />}
          placeholder='+7 (999) 999-99-99'
          label='Номер телефона'
          value={phone}
          onChange={handlePhoneChange}
          error={phone.length > 0 && isError}
          onKeyDown={handlePhoneKeyDown}
        />
        <Message type='info'>
          На указанный номер телефона будет направлен код подтверждения, который нужно будет ввести далее
        </Message>
      </Flex>

      <Flex
        direction='column'
        gap={10}
      >
        {isError && phone.length > 0 && (
          <Message
            type='error'
            title='Ошибка ввода'
          >
            Телефон введен неверно
          </Message>
        )}
        <Button
          color='red'
          disabled={phone.length === 0 || isError}
          onClick={handleRegisterClick}
        >
          Регистрация
        </Button>
      </Flex>
    </Flex>
  );
}

export default FramePhone;
